import request from '../../utils/request'

export function fetchList (data) {
  return request.post('/business/banner/page', data, {
    trim: true
  })
}

export function create (data) {
  return request.post('/business/banner/create', data)
}

export function updateStatus (data) {
  return request.post('/business/banner/updateStatus', data)
}

export function updateById (data) {
  return request.post('/business/banner/updateById', data)
}

export function getById (id) {
  return request.get(`/business/banner/${id}`)
}

export function deleteById (id) {
  return request.get(`/business/banner/delete/${id}`)
}

export function deleteByIdInBatch (ids) {
  return request.get('/business/banner/delete/batch', {
    params: {
      ids
    }
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/banner/exportExcel', data, {
    download: true,
    trim: true
  })
}
